import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CardCart from '../CardCart/CardCart';
import CardCartConfirm from '../CardCartConfirm/CardCartConfirm';

const CartBlock = ({...props}) => {
    
    useEffect(() => {

    }, [props.cart.carts]);
  
    const renderCards = () => (
        (props.type == "cart" && props.cart.carts && props.cart.carts.length > 0) ?
        props.cart.carts.map((item,index) => (
            item.quantity > 0 ? <CardCart item={item} key={index} widthDetail="220" /> : null
        )) : props.list.map((item,index) => (
            <CardCartConfirm item={item} key={index} widthDetail="120" type={props.type} />
        ))
    )
    
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0
    })

    const totalPriceCart = () => {
        //Local Storage sessionProducts
        let sessionProducts = []
        if(props.cart.carts && props.cart.carts.length > 0)
          sessionProducts = props.cart.carts
        else 
          sessionProducts = []

        let total = 0
        sessionProducts.forEach((element) => {
            total += element.quantity*element.price
        }) 
        
        if(props.type == "confirm"){
            return(
                <div className="row">
                    <div className="col d-flex justify-content-end" style={{ paddingRight:60, fontSize:18 }}>
                        Tổng cộng: <b style={{ paddingLeft:5 }}> {formatter.format(total)} </b>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
        <div className="container" style={{ marginTop: 50 }}>
            <div className="row" id="hideTop">
                <div className="col-md-4 text-center">
                    Sản Phẩm
                </div>
                <div className="col-md-8 text-center">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            Đơn Giá
                        </div>
                        <div className="col-md-4 text-center">
                            Số Lượng
                        </div>
                        <div className="col-md-4 text-center">
                            Tổng
                        </div>
                    </div>
                </div>
            </div>
            <hr className="divider" />
            <div style={{ display:'flex', flexDirection:'column' }}>
                {renderCards()}
            </div>
            <div>
                {totalPriceCart()}
            </div>
        </div>
        </>
    )
};

const mapStateToProps = (state) => {
    return {
      cart: state.cart,
    };
  };
  
export default connect(mapStateToProps)(CartBlock);